const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

export const retroDateFor = (now = new Date()) => {
  const date = new Date(now);
  date.setFullYear(2012);
  return date;
};

export const ordinalDay = day => {
  const suffix = day % 100 >= 11 && day % 100 <= 13
    ? "th"
    : ({ 1: "st", 2: "nd", 3: "rd" }[day % 10] || "th");
  return `${day}${suffix}`;
};

export const formatMsnDate = date => {
  const weekday = date.toLocaleDateString("en-GB", { weekday: "long" });
  const day = ordinalDay(date.getDate());
  const month = date.toLocaleDateString("en-GB", { month: "long" });
  const year = date.getFullYear();
  return `${weekday} ${day} ${month} ${year}`;
};

export const formatArticleMetadata = value => value.replace(
  /\b(\d{1,2})(?:st|nd|rd|th)?\s+(January|February|March|April|May|June|July|August|September|October|November|December)\s+(\d{4})\b/g,
  (_, day, month, year) => {
    const monthNumber = MONTHS.indexOf(month) + 1;
    return `${day.padStart(2, "0")}/${String(monthNumber).padStart(2, "0")}/${year.slice(-2)}`;
  }
);

export const formatSiteUptime = (now = new Date()) => {
  const parts = Object.fromEntries(
    new Intl.DateTimeFormat("en-GB", {
      timeZone: "Europe/London",
      year: "numeric",
      month: "numeric",
      day: "numeric"
    })
      .formatToParts(now)
      .filter(part => part.type !== "literal")
      .map(part => [part.type, Number(part.value)])
  );

  let years = parts.year - 2023;
  let months = parts.month - 7;
  let days = parts.day - 2;

  if (days < 0) {
    months -= 1;
    days += new Date(Date.UTC(parts.year, parts.month - 1, 0)).getUTCDate();
  }
  if (months < 0) {
    years -= 1;
    months += 12;
  }

  return `System uptime: ${years} years, ${months} months, ${days} days`;
};
